import { buildFilterUrl, formatFilterQuery } from '../../helper/api';
import { removeTrailingSlash } from '../../helper';
import { appSetPageData, appUpdateData } from './app';

export const FILTER_LOADING = 'FILTER_LOADING';
export const FILTER_ERROR = 'FILTER_ERROR';
export const FILTER_INIT = 'FILTER_INIT';
export const FILTER_POP = 'FILTER_POP';
export const FILTER_PUSH = 'FILTER_PUSH';
export const FILTER_RESET = 'FILTER_RESET';
export const FILTER_UPDATE_QUERY = 'FILTER_UPDATE_QUERY';

export const filterLoading = loading => ({ type: FILTER_LOADING, loading });
export const filterError = () => ({ type: FILTER_ERROR });
export const filterInit = (value, key = 'filteredValues') => ({
  type: FILTER_INIT,
  value,
  key
});
export const filterPopValue = (value, key = 'filteredValues') => ({ type: FILTER_POP, value, key });
export const filterPushValue = (value, key = 'filteredValues') => ({
  type: FILTER_PUSH,
  value,
  key
});
export const filterResetValues = (key = 'filteredValues') => ({ type: FILTER_RESET, key });

export const filterFetchData = () => {
  return async (dispatch, getState) => {
    // contains the current state object
    const state = getState();
    const { filteredValues } = state.filter;

    const path = window.location.pathname;

    dispatch(filterLoading(true));

    fetch(buildFilterUrl(removeTrailingSlash(path), filteredValues))
      .then(res => res.json())
      .then(data => {
        if (typeof data.error !== 'undefined') {
          filterError();
          filterResetValues();
        } else {
          dispatch(appSetPageData(data));
        }
      })
      .catch(() =>
        dispatch(() => {
          filterError();
          filterResetValues();
        })
      )
      .then(() => {
        if (document && window) {
          const body = document.body.getBoundingClientRect();
          const filterResults = document.getElementById('filter-results').getBoundingClientRect();
          const offset = filterResults.top - body.top;

          window.scrollTo({
            top: offset - 60,
            left: 0,
            behavior: 'smooth'
          });
        }
      })
      .finally(() => dispatch(filterLoading(false)));
  };
};

export const filterFetchTagsData = () => {
  return async (dispatch, getState) => {
    // contains the current state object
    const state = getState();
    const { filteredTags } = state.filter;
    const { listUrl } = state.app.pageData;

    const category = listUrl.split('?')[1].split('&')[0];
    const filterQuery = formatFilterQuery(filteredTags, 'tags');

    const dataUrl = `${listUrl.split('?')[0]}?${category}${
      filterQuery !== '' ? `&${filterQuery}` : ''
    }&page=1`;

    dispatch(filterLoading(true));

    fetch(dataUrl)
      .then(res => res.json())
      .then(json => {
        dispatch(appUpdateData('listData', json));
      })
      .catch(() => dispatch(() => filterError()))
      .finally(() => dispatch(filterLoading(false)));
  };
};
